
<div>
  <slot></slot>
  <p>Relationship: {{ objectModelAction.linked_account_relationship_title }}</p>
</div>
